import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const raporSorgusu = z.object({
    baslangic: z.string().datetime(),
    bitis: z.string().datetime(),
    noktaId: z.string().optional(),
});
export const gelirRaporu = z.object({
    araliki: z.object({ baslangic: z.string().datetime(), bitis: z.string().datetime() }),
    toplam: z.array(z.object({
        paraBirimi,
        tutar: z.string(),
        sayi: z.number().int(),
    })),
    saglayiciDagilimi: z.array(z.object({
        saglayici: z.string(),
        paraBirimi,
        tutar: z.string(),
        sayi: z.number().int(),
    })),
    gunluk: z.array(z.object({
        gun: z.string(),
        tutar: z.string(),
        sayi: z.number().int(),
    })),
    iadeToplam: z.array(z.object({
        paraBirimi,
        tutar: z.string(),
        sayi: z.number().int(),
    })),
});
export const analitikRaporu = z.object({
    araliki: z.object({ baslangic: z.string().datetime(), bitis: z.string().datetime() }),
    toplamKiralama: z.number().int(),
    tamamlanan: z.number().int(),
    iptalEdilen: z.number().int(),
    ortalamaSureDk: z.number(),
    noktaPerformans: z.array(z.object({
        noktaId: z.string(),
        noktaKod: z.string(),
        noktaAd: z.string(),
        kiralamaSayisi: z.number().int(),
        toplamGelir: z.string(),
        paraBirimi,
    })),
});
//# sourceMappingURL=rapor.js.map